import React, { useState, useEffect } from 'react';
import './FiltersView.css';

const FiltersView = ({
  show,
  onClose,
  filters,
  onFiltersChange,
  filterOptions,
  filteredRoomCount,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // null, 'rate', 'room', 'bed'

  // This effect handles the slide-out animation
  useEffect(() => {
    if (!show) {
      setIsClosing(true);
      const timer = setTimeout(() => {
        setIsClosing(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const handleClose = () => {
    setOpenDropdown(null); // Close any open dropdowns
    if (onClose) {
      onClose();
    }
  };

  const handleSortChange = (e) => {
    onFiltersChange({ ...filters, sortBy: e.target.value });
  };
  
  const handleToggleAccessible = () => {
    onFiltersChange({ ...filters, accessibleOnly: !filters.accessibleOnly });
  };
  
  const handleCheckboxChange = (filterType, value) => {
    const currentValues = filters[filterType] || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value];
    onFiltersChange({ ...filters, [filterType]: newValues });
  };

  const handleReset = () => {
    onFiltersChange({
      sortBy: 'price_asc',
      rateTypes: [],
      roomTypes: [],
      bedTypes: [],
      accessibleOnly: false,
    });
  };

  if (!show && !isClosing) {
    return null;
  }

  const overlayClass = `filters-overlay ${show && !isClosing ? 'visible' : ''}`;

  const Dropdown = ({ title, filterType, options }) => (
    <div className="custom-dropdown">
      <button 
        className={`dropdown-toggle ${openDropdown === filterType ? 'open' : ''}`}
        onClick={() => setOpenDropdown(openDropdown === filterType ? null : filterType)}
      >
        <span>{title}</span>
        <span className="dropdown-arrow"></span>
      </button>
      {openDropdown === filterType && (
        <div className="dropdown-menu">
          {options.map(option => (
            <label key={option} className="checkbox-label">
              <input 
                type="checkbox"
                checked={filters[filterType].includes(option)}
                onChange={() => handleCheckboxChange(filterType, option)}
              />
              <span className="checkbox-custom"></span>
              {option}
            </label>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div className={overlayClass} onClick={handleClose}>
      <div className="filters-container" onClick={(e) => e.stopPropagation()}>
        <div className="filters-header">
          <h2 className="filters-title">Filters & Sort</h2>
          <button className="close-button" onClick={handleClose}>
            Done
          </button>
        </div>
        <div className="filters-content">
          <div className="filter-group">
            <h3 className="filter-group-title">SORTING</h3>
            <div className="radio-group">
              <label className="radio-label">
                <input type="radio" name="sort" value="price_asc" checked={filters.sortBy === 'price_asc'} onChange={handleSortChange} />
                <span className="radio-custom"></span>
                Price: Low to High
              </label>
              <label className="radio-label">
                <input type="radio" name="sort" value="price_desc" checked={filters.sortBy === 'price_desc'} onChange={handleSortChange} />
                <span className="radio-custom"></span>
                Price: High to Low
              </label>
            </div>
          </div>

          <div className="filter-group">
            <h3 className="filter-group-title">ROOM FILTERS</h3>
            <div className="select-group">
              <Dropdown title="RATE TYPE" filterType="rateTypes" options={filterOptions.rateTypes} />
              <Dropdown title="ROOM TYPE" filterType="roomTypes" options={filterOptions.roomTypes} />
              <Dropdown title="BED TYPE" filterType="bedTypes" options={filterOptions.bedTypes} />
            </div>
          </div>

          <div className="filter-group">
            <div className="toggle-group">
              <label htmlFor="accessible-toggle" className="toggle-label">ACCESSIBLE ROOMS</label>
              <label className="switch">
                <input id="accessible-toggle" type="checkbox" checked={filters.accessibleOnly} onChange={handleToggleAccessible} />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div className="filters-footer">
          <button className="show-results-button" onClick={handleClose}>Show {filteredRoomCount} Results</button>
          <button className="reset-filters-button" onClick={handleReset}>Reset Filters</button>
        </div>
      </div>
    </div>
  );
};

export default FiltersView; 